import {Parameter, ToolboxPortfolioPortfolio} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalPortfolioAdd} from "./PortalPortfolioAdd";

export class PortalToolboxPortfolioPortfolio extends ToolboxPortfolioPortfolio implements Parameter {
	constructor(data: any) {
		super(data);

		this.add = PortalPortfolioAdd.fromJson(data?.add);
	}

	public static fromJson(data: any): PortalToolboxPortfolioPortfolio {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxPortfolioPortfolio(data);
	}

	public clone(): PortalToolboxPortfolioPortfolio {
		return PortalToolboxPortfolioPortfolio.fromJson(this.toJson());
	}
}